import { createApi } from '@reduxjs/toolkit/query/react';

import { DeleteResponseDto } from '../common/dto/common.dto';
import { NotificationViewDto } from '../common/dto/notification.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'Notification';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: customFetchBase(`${API_URI}/api/notification`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    getNotificationList: builder.query<NotificationViewDto[], void>({
      query() {
        return {
          url: ``,
          method: 'GET',
        };
      },
      // invalidatesTags: [{ type: 'ResetPassword' }],
    }),
    markRead: builder.mutation<NotificationViewDto, string>({
      query(id: string) {
        return {
          url: `${id}`,
          method: 'PUT',
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),

    clearAllNotification: builder.mutation<DeleteResponseDto, void>({
      query() {
        return {
          url: `clear-all`,
          method: 'DELETE',
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useLazyGetNotificationListQuery, useClearAllNotificationMutation, useMarkReadMutation } = notificationApi;
